import {Component, input} from '@angular/core';
import {MatCard, MatCardContent, MatCardHeader, MatCardImage, MatCardTitle} from '@angular/material/card';
import {Scheme} from '../../domain/scheme.model';

@Component({
  selector: 'app-scheme-card',
  imports: [
    MatCard,
    MatCardTitle,
    MatCardHeader,
    MatCardImage,
    MatCardContent,
  ],
  templateUrl: './scheme-card.html',
  styleUrl: './scheme-card.scss',
})
export class SchemeCard {
  scheme = input.required<Scheme>();
}
